import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  countdownFinished: false,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setCountdownFinished: (state) => {
      state.countdownFinished = true;
    },
    // Optional: if you ever need to reset it (e.g. after logout or long inactivity)
    resetCountdown: (state) => {
      state.countdownFinished = false;
    },
  },
});

export const { setCountdownFinished, resetCountdown } = sessionSlice.actions;

export default sessionSlice.reducer;